import { Link } from 'react-router-dom'
import { BookOpen } from 'lucide-react'

// A single book cover card: cover + title + author, matching the mobile app.
// Links to the public book detail page by internal book id.
const BookCard = ({
  book,
  width = 'w-32 sm:w-36 shrink-0',
  className = '',
  coverClassName = '',
  titleClassName = '',
  authorClassName = '',
  imageFit,
  linkState,
}) => {
  const linkId = book?.id ?? book?.isbn13
  const cover = book?.coverUrl
  const isGridCard = width.includes('w-full')
  const resolvedImageFit = imageFit || (isGridCard ? 'cover' : 'contain')

  const coverFrameClass = isGridCard
    ? 'aspect-[2/3] w-full overflow-hidden'
    : 'flex h-52 w-fit max-w-[190px] items-center justify-center sm:h-56 sm:max-w-[210px]'

  const coverImageClass = isGridCard
    ? `h-full w-full ${resolvedImageFit === 'contain' ? 'object-contain' : 'object-cover'}`
    : 'h-full w-auto max-w-full object-contain'

  const placeholderClass = isGridCard
    ? 'h-full w-full'
    : 'h-52 w-36 sm:h-56 sm:w-40'

  const inner = (
    <>
      <div className={`rounded-xl bg-bg-soft shadow-app-card ${coverFrameClass} ${coverClassName}`}>
        {cover ? (
          <img
            src={cover}
            alt={book?.title || 'Book cover'}
            loading="lazy"
            className={coverImageClass}
          />
        ) : (
          <div className={`flex items-center justify-center text-primary-300 ${placeholderClass}`}>
            <BookOpen size={28} />
          </div>
        )}
      </div>
      <div className="mt-2">
        <div className={`text-sm font-semibold text-text-primary leading-snug line-clamp-2 ${titleClassName}`}>
          {book?.title || 'Untitled'}
        </div>
        {book?.author && (
          <div className={`text-xs text-text-secondary mt-0.5 line-clamp-1 ${authorClassName}`}>
            {book.author}
          </div>
        )}
      </div>
    </>
  )

  const base = isGridCard
    ? `block ${width} transition-transform duration-200 hover:-translate-y-1 ${className}`
    : `inline-flex w-max max-w-[190px] shrink-0 flex-col transition-transform duration-200 hover:-translate-y-1 sm:max-w-[210px] ${className}`

  return linkId ? (
    <Link to={`/book/${encodeURIComponent(linkId)}`} state={linkState} className={base}>
      {inner}
    </Link>
  ) : (
    <div className={base}>{inner}</div>
  )
}

export default BookCard
